import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=6b3edf00&scoped=true&"
import script from "./PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./PasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./PasswordEdit.vue?vue&type=style&index=0&id=6b3edf00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3edf00",
  null
  
)

export default component.exports